<template>
  <div class="flex flex-wrap justify-center">
    <div class="w-3/4 lg:w-1/2 xl:w-1/3">
      <div class="h3 text-secondary text-center mb-8">
        Veelgestelde vragen
      </div>

      <div class="relative">
        <nuxt-link :to="{name: 'vragen'}" class="absolute btn btn-secondary-invert left-0 top-0 -ml-48 w-auto inline-block text-sm">
          <font-awesome-icon :icon="['fas', 'chevron-left']" size="sm" class="mr-2"/>
          Terug
        </nuxt-link>
        <div v-if="!$apollo.loading">
          <h4>{{ vraag.title }}</h4>
          <div class="prose" v-html="vraag.antwoord"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vraag from '~/graphql/queries/vraag';

export default {
  apollo: {
    vraag: {
      query: vraag,
      prefetch: ({route}) => ({slug: route.params.slug}),
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
};
</script>
